import { createRequest } from "./request";
import { API_URL } from "../../config/index";
const BASE_URL = API_URL;
const request = createRequest(BASE_URL);

export const signup = (email, password) => {
  return request("/signup", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });
};

export const signin = (email, password) => {
  return request("/signin", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });
};

export const signout = () => {
  return request("/signout", {
    method: "DELETE",
  });
};

export const getProfile = () => {
  return request("/profile", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const forgotPassword = (email) => {
  return request("/forgot-password", {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });
};

export const resetPassword = (
  newPassword,
  confirmPassword,
  resetPasswordLink,
) => {
  return request(`/reset-password/${resetPasswordLink}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ newPassword, confirmPassword }),
  });
};

export const validateResetPasswordLink = (resetPasswordLink, signal) => {
  return request(`/reset-password/${encodeURIComponent(resetPasswordLink)}`, {
    method: "GET",
    cache: "no-store",
    signal,
  });
};
